import Audio from "../../components/Audio/Audio";
import { TEXT_COLOR } from "../../theme";
import { mintUploadAudioStyles } from "./styles";
import { MintUploadAudioProps } from "./types";

export const MintUploadAudio: React.FC<MintUploadAudioProps> = ({
  errors,
  touched,
  handleBlur,
  setFieldValue,
  isSubmitting,
  saveResetAudioAction,
  location,
  trackTitle,
  handleSongChanged,
  trackUrl,
}) => {
  return (
    <>
      <label
        style={{
          color: errors.songUpload && touched.songUpload ? "red" : TEXT_COLOR,
        }}
        htmlFor="audio"
        className="uploadLabel"
      >
        Upload Audio
        <span className="asterisk">*</span>
      </label>
      <Audio
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        touched={touched}
        errors={errors}
        isSubmitting={isSubmitting}
        transferClearAudio={saveResetAudioAction}
        dawExportedBlob={location.state?.dawExportedBlob}
        songTitle={trackTitle ?? ""}
        songUrl={trackUrl}
        handleSongChanged={handleSongChanged}
      />
      <p style={mintUploadAudioStyles.fileSupported}>
        File type supported: MP3, WAV, OGG. Max size: 100 MB
      </p>
    </>
  );
};
